// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox__2xPBR","disabled":"disabled__3WJGe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/styles.scss
// module id = 2121
// module chunks = 1